import { Service } from '@angular/core';

import { BarErrorHandlerHook, BarErrorHandlerHookArgs } from '@lvflanders/bar-ng';

// NOTE throw warning in case these messages are thrown
const ERRORS_RESIZE_OBSERVER = ['ResizeObserver loop limit exceeded', 'ResizeObserver loop completed with undelivered notifications'];

@Service({ autoProvided: false })
export class BaasResizeObserverErrorHandlerHook implements BarErrorHandlerHook {
    /** Invoked by the error handler. */
    run(args: BarErrorHandlerHookArgs): void {
        // NOTE we can get this error due to the header/flanders footer burgerprofiel or ag-grid
        // https://stackoverflow.com/a/50387233/2174621
        const errorMessage = args.error?.message || args.error;

        if (errorMessage && typeof errorMessage === 'string' && ERRORS_RESIZE_OBSERVER.some((resizeError) => errorMessage.includes(resizeError))) {
            args.handled = true;
            // warning, still notify that this problem exists
            console.warn(args.error);
        }
    }
}
